import StablishmentEntity from "./StablishmentEntity";

export default class QrBatchEntity {
    public id: string;
    // public stablishment: StablishmentEntity;
    public createdAt: Date;
    public availables: number;
    public used: number;
    public disabled?: boolean;

    constructor(data: {
        id: string;
        // stablishment: StablishmentEntity;
        createdAt?: Date;
        availables: number;
        used: number;
        disabled?: boolean;
    }) {
        this.id = data.id;
        // this.stablishment = data.stablishment;
        this.createdAt = data.createdAt || new Date();
        this.availables = data.availables || 0;
        this.used = data.used || 0;
        this.disabled = data.disabled || false;
    }

    public copyWith(data: {
        id?: string;
        stablishment?: StablishmentEntity;
        createdAt?: Date;
        availables?: number;
        used?: number;
        disabled?: boolean;
    }): QrBatchEntity {
        return new QrBatchEntity({
            id: data.id ?? this.id,
            // stablishment: data.stablishment ?? this.stablishment,
            createdAt: data.createdAt ?? this.createdAt,
            availables: data.availables ?? this.availables,
            used: data.used ?? this.used,
            disabled: data.disabled ?? this.disabled,
        });
    }

    public toString(): string {
        return `QrBatchEntity{id: ${this.id}, createdAt: ${this.createdAt}}`;
    }
}